module.exports = __webpack_public_path__ + "static/img/FullBodyXRAY8.4a561720.jpg";